/**
 * Release 4 switch for scanning web pages in Brand Setup step 1 (lane W5 flipped it when the scanner
 * shipped). On: step 1 shows the web-page box (step1/UrlListBox.tsx), Next sends its addresses with the
 * document in one import, and the Release 4 sentences name web pages and URLs (spec:64, :87). Off, the
 * box renders nothing and no sentence mentions them. Like every Release 4 feature it is reached only
 * while the install's Brand Workspace v2 switch (PlatformSettings.brandWorkspaceV2At) is on. One file
 * per Release 4 lane, so each lane flips only its own.
 */
export const URL_SCAN_ENABLED: boolean = true;
